import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: _normalizeClass(["item", { active: $props.modelValue === $setup.Position.LEFT }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.change($setup.Position.LEFT)))
    }, " 左 ", 2),
    _createElementVNode("a", {
      class: _normalizeClass(["item", { active: $props.modelValue === $setup.Position.RIGHT }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.change($setup.Position.RIGHT)))
    }, " 右 ", 2)
  ]))
}